import type { IFirstClientMountService } from '@services/FirstClientMountService';
import type { AuthStatus } from '@unitedtraders/utex-site-common';
import { inject, injectable } from 'inversify';
import { action, computed, IReactionDisposer, makeObservable, observable, when } from 'mobx';

import { iocNames } from '../iocNames';
import { SessionService } from '../services/SessionService';

@injectable()
export class AuthStore implements AuthStatus {
  private firstClientMountDisposer: IReactionDisposer;

  @observable
  isUserAuthorized?: boolean;

  @observable
  private isUserDidLoginOnce?: boolean;

  constructor(
    @inject(iocNames.sessionService) sessionService: SessionService,
    @inject(iocNames.firstClientMountService)
    private firstClientMountService: IFirstClientMountService
  ) {
    makeObservable(this);

    this.firstClientMountDisposer = when(
      () => !this.firstClientMountService.isFirstClientMount,
      () => {
        sessionService.isAuthorized.subscribe(isUserAuthorized => {
          this.setIsUserAuthorized(isUserAuthorized);
          this.setUserDidLoginOnce(sessionService.wasLoginedIn.valueOf());
        });
      }
    );
  }

  @computed
  get userDidLoginOnce() {
    return this.isUserDidLoginOnce;
  }

  @action
  setIsUserAuthorized = (status?: boolean) => {
    this.isUserAuthorized = status;
  };

  @action
  private setUserDidLoginOnce = (status?: boolean) => {
    this.isUserDidLoginOnce = status;
  };

  dispose() {
    this.firstClientMountDisposer();
  }
}
